<template>
  <div class="auth-main auth-main__join-invite">
    <main
      id="main"
      class="main--login"
    >
      <section class="section-login">
        <Header :is-whitelabel="isWhitelabel" />
        <div class="login-form-wrapper">
          <div class="loginv2-container p-b-20">
            <div class="row">
              <div
                class="login_logo"
                :class="{ 'login_logo--ringba': !isWhitelabel }"
              />
            </div>
            <InvalidInvite
              v-if="!inviteStatus.isInvitationValid"
              :invite-status="inviteStatus"
            />
            <JoinExistingUser
              v-if="inviteStatus.isInvitationValid && inviteStatus.userExists"
            />
            <JoinInviteForm
              v-if="inviteStatus.isInvitationValid && !inviteStatus.userExists"
              :initial-first-name="inviteData.firstName"
              :initial-last-name="inviteData.lastName"
              :action-status="actionStatus"
              @join-invite="onJoinInvite"
            />
          </div>
        </div>
      </section>
      <Footer v-if="!isWhitelabel" />
      <WhitelabelFooter v-if="isWhitelabel" />
    </main>
  </div>
</template>

<script>
import Footer from '@/modules/auth/components/Footer';
import Header from '@/modules/auth/components/Header';
import JoinExistingUser from '@/modules/auth/components/JoinInvite/JoinExistingUser';
import JoinInviteForm from '@/modules/auth/components/JoinInvite/JoinInviteForm';
import InvalidInvite from '@/modules/auth/components/JoinInvite/InvalidInvite';
import WhitelabelFooter from '@/modules/auth/components/WhitelabelFooter';
import { mapState, mapActions } from 'vuex';
import { getStatus } from '@/store/helpers';

export default {
  components: { Footer, Header, JoinExistingUser,JoinInviteForm, InvalidInvite, WhitelabelFooter },
  props: {
    isWhitelabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    inviteStatus: {
      type: Object,
      default() {
        return {};
      },
    },
    inviteData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapState('auth', {
      actionStatus: (state) => getStatus(state, 'sendJoinInviteRequest')
    })
  },
  methods: {
    ...mapActions('auth', ['sendJoinInviteRequest']),
    async onJoinInvite(requestData) {
      await this.sendJoinInviteRequest({inviteId: this.inviteStatus.invitationId, requestData});
    },
  },
};
</script>

<style>
.auth-main__join-invite {
  --component-login__welcome-message: var(--component-join-invite__welcome-message);
}
</style>